// import * as React from 'react';
import { PROPERTY_LIST } from '../../../assets/schema/property';
import { useArray } from '../../../hooks/useArray';
import { stringToCamelCase } from '../../../utilities/others';
import { PropertyIndexes, PropertySchema } from './../property/Property.types';

export function useTableProperties(properties?: PropertySchema[]) {  
  const { data, add, reorder, update, remove } = useArray<PropertySchema>(properties || PROPERTY_LIST);

  function handlePropertyAdd(value?: Pick<PropertySchema, "label" | "type" | "name">) {
      let column = {} as PropertySchema;
      if (value) {
        column = {
          isHidden: false,
          label: value.label,
          id: data.length + 1,
          name: stringToCamelCase(value.name!)!,
          type: value.type.toUpperCase()
        }
      } else {
          column = {
            isHidden: false,
            label: "Column",
            id: data.length + 1,
            type: "text".toUpperCase(),
            name: `Column ${data.length}`
          }
      }

      add(column)
    }

    function handlePropertyUpdate(value: PropertySchema, index: number) {
        update(value, index)
    }

    function handlePropertyDelete(index: number) {
        remove(index)
    }

    function handlePropertyDuplicate(value: PropertySchema) {
        add({...value, isHidden: false })
    }

    function handlePropertyDrag({ oldIndex, newIndex }: PropertyIndexes) {
        reorder(oldIndex, newIndex)
    }

    return {
      properties: data,
      onPropertyAdd: handlePropertyAdd,
      onPropertyDrag: handlePropertyDrag,
      onPropertyUpdate: handlePropertyUpdate,
      onPropertyDelete: handlePropertyDelete,
      onPropertyDuplicate: handlePropertyDuplicate
    };
}
